module.exports = __webpack_public_path__ + "media/images/en/upload-kies-9df940177804aba03747e9e5da85c982.png";